import { EntityModules } from 'core/constants';
import routes from 'core/routes';

export type FormBuilderMode = {
  entityType: EntityModules.Audits | EntityModules.RisksAssessments;
  conditionalLogic: boolean;
  scoring: boolean;
  singleSiteQuestion: boolean;
  confirmPublish: boolean;
  routes: { list: string; details: string };
  breadcrumbs: { label: string; link: string }[];
  copy: {
    submitLabel: string;
    futureRecords: string;
    publishedSnackbar: string;
    republishedSnackbar: string;
    discardBody: string;
    respondents: string;
    publishConfirmBody: string;
  };
};

export const AUDITS_BUILDER_MODE: FormBuilderMode = {
  entityType: EntityModules.Audits,
  conditionalLogic: true,
  scoring: true,
  singleSiteQuestion: false,
  confirmPublish: false,
  routes: {
    list: routes.dashboard.audits.templates.toString(),
    details: routes.dashboard.audits.templates.details,
  },
  breadcrumbs: [
    { label: 'Audits', link: routes.dashboard.audits.forms.toString() },
    { label: 'Templates', link: routes.dashboard.audits.templates.toString() },
  ],
  copy: {
    submitLabel: 'Submit audit',
    futureRecords: 'future audits',
    publishedSnackbar: 'Template published. It is now available to auditors.',
    republishedSnackbar: 'Changes published.',
    discardBody:
      'Everything you have changed since the last publish will be lost. Auditors keep using the published version either way.',
    respondents: 'auditors',
    publishConfirmBody: 'New audits will use it. Audits already started keep the questions they started with.',
  },
};

export const RISK_ASSESSMENT_BUILDER_MODE: FormBuilderMode = {
  entityType: EntityModules.RisksAssessments,
  conditionalLogic: false,
  scoring: false,
  singleSiteQuestion: true,
  confirmPublish: true,
  routes: {
    list: routes.dashboard.risks.templates.toString(),
    details: routes.dashboard.risks.templates.details,
  },
  breadcrumbs: [
    { label: 'Risks', link: routes.dashboard.risks.riskRegister },
    { label: 'Risk assessment templates', link: routes.dashboard.risks.templates.toString() },
  ],
  copy: {
    submitLabel: 'Submit assessment',
    futureRecords: 'future assessments',
    publishedSnackbar: 'Template published',
    republishedSnackbar: 'Template published',
    discardBody:
      'Everything you have changed since the last publish will be lost. Risk assessors keep using the published template either way.',
    respondents: 'risk assessors',
    publishConfirmBody:
      'New assessments will use it. Assessments already started keep the questions they started with.',
  },
};
